module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADKSURBVHgB7ZS9DYMwEIXPJgMYJCTKtHRkE1bIBskkjMAKySSho00J4kdmAHDeRSRSUtkWJZ9k2TpZn8/FO0GgruujMabEMcNSZM9NCHFN0/QpVskjjmMVRRFJKa0My7LQNE3UNI2G7HRAoUiS5C1xgR8Mw5DmeVZd15UStlwpl9/8wjKQyY/dlyAIeFP+hj920S7aSqQ5gL4ga19RNQwD+cITANPjzqE9932vx3Ekl874LlJPbdtqZPUiuLjOpALHnOzRWBU3woPtBSt2VDa8xjlYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_b2c/checkbox-inactive.png
// module id = kRK+
// module chunks = 1